import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';
import { WindowLocationService } from 'pf-frontend-common/src/service/window-location/service';

import { MyAccountToggleSaveButtonViewStore } from 'common/module/my-account/toggle-save-button/view-store';
import { PropertySavedStatechartStoreFactory } from 'common/module/property/saved/statechart/store.factory';
import { UserAuthTrackerFactory } from 'common/module/user/auth/tracker.factory';
import { MessageService } from 'common/service/message/service';
import { MyAccountToggleSaveButtonInteractionService } from 'common/service/my-account-toggle-save-button-interaction/service';
import { MyAccountToggleSaveButtonStatsService } from 'common/service/my-account-toggle-save-button-stats/service';
import { PropertySavedStoreService } from 'common/service/property-saved-store/service';
import { StatsGtmProviderService } from 'common/service/stats-gtm-provider/service';
import { StatsTealiumProviderService } from 'common/service/stats-tealium-provider/service';
import { UserAuthenticationService } from 'common/service/user-authentication/service';

MyAccountToggleSaveButtonStatsService().initialize();

export function MyAccountToggleSaveButtonViewStoreFactory(): MyAccountToggleSaveButtonViewStore {
  return new MyAccountToggleSaveButtonViewStore(
    EventEmitterFactory(),
    PropertySavedStatechartStoreFactory(),
    PropertySavedStoreService(),
    UserAuthenticationService(),
    MyAccountToggleSaveButtonInteractionService(),
    StatsGtmProviderService(),
    StatsTealiumProviderService(),
    MessageService(),
    WindowLocationService(),
    UserAuthTrackerFactory()
  );
}
